"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwilioMetaConfigSchema = exports.TwilioAdditionalConfigSchema = exports.TwilioMetaConfigSchemaObj = exports.TwilioAdditionalConfigSchemaObj = exports.TwilioAllowedMethod = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const urlRegex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
var TwilioAllowedMethod;
(function (TwilioAllowedMethod) {
    TwilioAllowedMethod["POST"] = "POST";
    TwilioAllowedMethod["PATCH"] = "PATCH";
    TwilioAllowedMethod["PUT"] = "PUT";
    TwilioAllowedMethod["DELETE"] = "DELETE";
})(TwilioAllowedMethod || (exports.TwilioAllowedMethod = TwilioAllowedMethod = {}));
exports.TwilioAdditionalConfigSchemaObj = {
    friendlyName: yup_lib_1.default.string().required(),
    inboundRequestUrl: yup_lib_1.default.string().matches(urlRegex, 'Please enter valid inbound url').required(),
    inboundMethod: yup_lib_1.default
        .mixed()
        .oneOf(Object.values(TwilioAllowedMethod))
        .required(),
    phoneNumberSid: yup_lib_1.default.array().of(yup_lib_1.default.string()).max(100).notRequired()
};
exports.TwilioMetaConfigSchemaObj = {
    messagingServiceSid: yup_lib_1.default.string().required()
};
exports.TwilioAdditionalConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.TwilioAdditionalConfigSchemaObj);
exports.TwilioMetaConfigSchema = yup_lib_1.default
    .object()
    .shape(exports.TwilioMetaConfigSchemaObj);
